
import React, { useState, useEffect } from "react";
import "./Adminprofile.css";
import { useDispatch, useSelector } from "react-redux";
// import admin_img from "../../../images/admin-img.svg";
import profile_picture from "../../../images/profile_picture.svg";
import default_pfp from "../../../images/default_pfp.svg";
import { fetchProfileData } from "../../../Services/Profile/ProfileApi";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function AdminprofileComp() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.fetchProfileData);
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [userEmail, setuseremail] = useState();
  const userId = localStorage.getItem("user_id");
  
  
  const userType = localStorage.getItem("user_type");
  const firstNm = localStorage.getItem("user_first_name");
  const lastNm = localStorage.getItem("user_last_name");
  const uerEm = localStorage.getItem("email");
  const phone_number=localStorage.getItem("phone");
  const location=localStorage.getItem("location");





  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchProfileData(userId)).finally(() => setLoading(false));
  }, [dispatch]);

  useEffect(() => {
    if (data) {
      setProfile(data?.data);
      setuseremail(data?.data?.email);

      
    }
  }, [data]);

  const handleSendEmail = () => {
    if (data) {
      navigate(`/change-password?email=${encodeURIComponent(userEmail)}`); // Pass email as a query parameter
    }
  };

  const handleUpdateProfile = () => {
    navigate("/user/update-user", { state: { profileData: profile } });
  };

  return (
    <>
     <div className="admin-profile-header-content">
        <div className="back-btn">
          <button onClick={() => navigate(-1)} className="back-btn-button">
            <ArrowBackIcon className="left-icon" />
            Back
          </button>
        </div>
      <div className="admin-profile-section">
        
        <div className="row admin-profile-wrapper" >
         
          <div className="col-10 m-auto admin-profile-inner " >
            <div className="admin-content-block d-flex">
              <div className="admin-pic-name">
                <div className="admin-img">
                  <img
                    src={profile?.image || default_pfp}
                    alt="Profile-picture"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src = default_pfp; // Fallback image
                    }}
                  />
                </div>
                <div className="admin-name text-center">
                  {profile?.first_name} {profile?.last_name}
                </div>
                <div className="admin-designation text-center">User</div>
              </div>
              <div className="admin-main-details">
                <div className="personal-details">Personal Details</div>
                <div className="table-admin">
                  <div className="table-admin-inner">
                    <table class="table table-borderless table-desktop-view">
                      <thead>
                        <tr>
                          <th scope="col">First Name</th>
                          <th scope="col">Last Name</th>
                          <th scope="col">Email address</th>
                          <th scope="col">Phone Number</th>
                          <th scope="col">Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {/* <td>{profile?.first_name} </td> */}
                          <td>{profile?.first_name} </td>
                          <td>{profile?.last_name}</td>
                          <td>{userEmail}</td>
                          <td>{profile?.phone_number}</td>
                          <td>{profile?.location}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table class="table table-borderless table-mobile-view">
                      <tbody>
                        <tr className="d-grid row-superadmin">
                          <td>{profile?.first_name} </td>
                          <td>{profile?.last_name}</td>
                          <td>{profile?.email}</td>
                          <td className="ph_number">{profile?.phone_number}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="change-edit-btns d-flex gap-3 justify-content-center ">
              {/* <div className="change-pw-btn text-end mt-3">
                <button onClick={handleSendEmail}>Change Password</button>
              </div> */}
              <div className="editprofile-btn text-end mt-3">
                <button onClick={handleUpdateProfile}>  Edit  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default AdminprofileComp;
